"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _rsManagement = require("@/api/rsManagement");
var _OrderDetail = _interopRequireDefault(require("./components/OrderDetail.vue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'HotelOrder',
  components: {
    OrderDetail: _OrderDetail.default
  },
  data: function data() {
    return {
      constants: this.$constants,
      loading: false,
      exportLoading: false,
      pageFrom: {
        page: 1,
        limit: 20,
        orderNo: '',
        productName: '',
        status: '',
        storeType: '',
        payStartTime: '',
        payEndTime: ''
      },
      payTimeRange: [],
      tableData: {
        list: [],
        total: 0
      },
      storeTypeOptions: [],
      refundDialogVisible: false,
      refundPreviewLoading: false,
      refundSubmitting: false,
      refundPreview: null,
      refundPreviewError: '',
      refundOrderNo: '',
      orderStatusOptions: [{
        value: 0,
        label: '已取消'
      }, {
        value: 1,
        label: '待支付'
      }, {
        value: 2,
        label: '已支付'
      }, {
        value: 3,
        label: '已使用'
      }, {
        value: 4,
        label: '退款中'
      }, {
        value: 41,
        label: '待退款'
      }, {
        value: 5,
        label: '退款成功'
      }, {
        value: 6,
        label: '退款失败'
      }, {
        value: 7,
        label: '部分退款'
      }, {
        value: 10,
        label: '已完结'
      }, {
        value: 15,
        label: '售后中'
      }]
    };
  },
  mounted: function mounted() {
    this.getList();
    this.fetchStoreTypeOptions();
  },
  methods: {
    fetchStoreTypeOptions: function () {
      var _fetchStoreTypeOptions = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return (0, _rsManagement.getMerchantStoreTypeList)();
            case 1:
              res = _context.v;
              this.storeTypeOptions = (res || []).filter(function (item) {
                return Number(item.type) === 3;
              });
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              console.error('获取店铺类型失败：', _t);
              this.storeTypeOptions = [];
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function fetchStoreTypeOptions() {
        return _fetchStoreTypeOptions.apply(this, arguments);
      }
      return fetchStoreTypeOptions;
    }(),
    // 获取列表数据
    getList: function () {
      var _getList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var params, res, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              this.loading = true;
              _context2.p = 1;
              // 处理时间范围
              params = _objectSpread({}, this.pageFrom); // 处理支付时间范围
              if (this.payTimeRange && this.payTimeRange.length === 2) {
                params.payStartTime = this.payTimeRange[0];
                params.payEndTime = this.payTimeRange[1];
              } else {
                params.payStartTime = '';
                params.payEndTime = '';
              }

              // 处理状态参数，如果是空字符串则删除
              if (params.status === '') {
                delete params.status;
              } else if (params.status !== undefined && params.status !== null) {
                params.status = Number(params.status);
              }

              // 清理空字符串参数（但保留 page 和 limit）
              Object.keys(params).forEach(function (key) {
                if (params[key] === '' && key !== 'page' && key !== 'limit') {
                  delete params[key];
                }
              });

              // 确保 page 和 limit 存在
              params.page = params.page || 1;
              params.limit = params.limit || 20;
              _context2.n = 2;
              return (0, _rsManagement.getJdAdminOrderList)(params);
            case 2:
              res = _context2.v;
              if (res) {
                this.tableData.list = res.list || [];
                this.tableData.total = res.total || 0;
              }
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t2 = _context2.v;
              console.error('获取酒店订单列表失败：', _t2);
              this.$message.error('获取数据失败：' + (_t2.message || '未知错误'));
              this.tableData.list = [];
              this.tableData.total = 0;
            case 4:
              _context2.p = 4;
              this.loading = false;
              return _context2.f(4);
            case 5:
              return _context2.a(2);
          }
        }, _callee2, this, [[1, 3, 4, 5]]);
      }));
      function getList() {
        return _getList.apply(this, arguments);
      }
      return getList;
    }(),
    // 搜索
    search: function search() {
      this.pageFrom.page = 1;
      this.getList();
    },
    exportOrders: function () {
      var _exportOrders = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var params, res, _t3;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              this.exportLoading = true;
              params = _objectSpread({}, this.pageFrom);
              if (this.payTimeRange && this.payTimeRange.length === 2) {
                params.payStartTime = this.payTimeRange[0];
                params.payEndTime = this.payTimeRange[1];
              } else {
                params.payStartTime = '';
                params.payEndTime = '';
              }
              if (params.status === '') {
                delete params.status;
              } else if (params.status !== undefined && params.status !== null) {
                params.status = Number(params.status);
              }
              Object.keys(params).forEach(function (key) {
                if (params[key] === '' && key !== 'page' && key !== 'limit') {
                  delete params[key];
                }
              });
              _context3.n = 1;
              return (0, _rsManagement.exportMerchantJdOrderList)(params);
            case 1:
              res = _context3.v;
              if (!(res && res.fileName)) {
                _context3.n = 2;
                break;
              }
              window.open(res.fileName);
              this.$message.success('开始导出');
              return _context3.a(2);
            case 2:
              this.$message.error('导出失败，未获取到下载地址');
              _context3.n = 4;
              break;
            case 3:
              _context3.p = 3;
              _t3 = _context3.v;
              console.error('导出酒店订单失败：', _t3);
              this.$message.error('导出失败：' + (_t3.message || '未知错误'));
            case 4:
              _context3.p = 4;
              this.exportLoading = false;
              return _context3.f(4);
            case 5:
              return _context3.a(2);
          }
        }, _callee3, this, [[0, 3, 4, 5]]);
      }));
      function exportOrders() {
        return _exportOrders.apply(this, arguments);
      }
      return exportOrders;
    }(),
    // 重置搜索
    resetSearch: function resetSearch() {
      this.pageFrom = {
        page: 1,
        limit: 20,
        orderNo: '',
        productName: '',
        status: '',
        storeType: '',
        payStartTime: '',
        payEndTime: ''
      };
      this.payTimeRange = [];
      this.getList();
    },
    // 分页大小改变
    handleSizeChange: function handleSizeChange(val) {
      this.pageFrom.limit = val;
      this.pageFrom.page = 1;
      this.getList();
    },
    // 页码改变
    pageChange: function pageChange(val) {
      this.pageFrom.page = val;
      this.getList();
    },
    // 格式化金额
    formatAmount: function formatAmount(amount) {
      if (amount === null || amount === undefined) return '0.00';
      return Number(amount).toFixed(2);
    },
    // 格式化平台收款
    formatPlatformCollection: function formatPlatformCollection(row) {
      var parts = [];
      // 总金额
      parts.push("\xA5".concat(this.formatAmount(row.totalPrice || 0)));

      // 福豆
      parts.push("\u798F\u8C46: ".concat(this.formatAmount(row.useIntegral || 0)));

      // 微信
      parts.push("\u5FAE\u4FE1: \xA5".concat(this.formatAmount(row.paidPrice || 0)));
      if (Number(row.oneCardDeductPrice) > 0) {
        parts.push("\u4E00\u5361\u901A\u6743\u76CA\u62B5\u6263: \xA5".concat(this.formatAmount(row.oneCardDeductPrice)));
      }
      return parts.join(' ');
    },
    // 获取状态名称
    getStatusName: function getStatusName(status) {
      var statusMap = {
        0: '已取消',
        1: '待支付',
        2: '已支付',
        3: '已使用',
        4: '退款中',
        41: '待退款',
        5: '退款成功',
        6: '退款失败',
        7: '部分退款',
        10: '已完结',
        15: '售后中'
      };
      return statusMap[status] || '未知';
    },
    // 获取状态类型（用于标签颜色）
    getStatusType: function getStatusType(status) {
      var typeMap = {
        0: 'info',
        1: 'warning',
        2: 'success',
        3: 'success',
        4: 'warning',
        41: 'warning',
        5: 'success',
        6: 'danger',
        7: 'warning',
        10: 'success',
        15: 'warning'
      };
      return typeMap[status] || '';
    },
    // 打开订单详情
    openOrderDetail: function openOrderDetail(orderNo) {
      this.$refs.orderDetailRef.open(orderNo);
    },
    // 取消订单
    handleCancelOrder: function handleCancelOrder(row) {
      var _this = this;
      this.$confirm('确定要取消该订单吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var _t4;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              _context4.p = 0;
              _context4.n = 1;
              return (0, _rsManagement.refund)(row.orderNo);
            case 1:
              _this.$message.success("\u8BA2\u5355 ".concat(row.orderNo, " \u53D6\u6D88\u6210\u529F"));
              _this.getList();
              _context4.n = 3;
              break;
            case 2:
              _context4.p = 2;
              _t4 = _context4.v;
              console.error('取消订单失败：', _t4);
              _this.$message.error('取消订单失败：' + (_t4.message || '未知错误'));
            case 3:
              return _context4.a(2);
          }
        }, _callee4, null, [[0, 2]]);
      }))).catch(function () {
        _this.$message.info('已取消操作');
      });
    },
    // 退款
    handleRefund: function handleRefund(row) {
      this.refundOrderNo = row.orderNo;
      this.refundDialogVisible = true;
      this.loadHotelRefundPreview();
    },
    loadHotelRefundPreview: function () {
      var _loadHotelRefundPreview = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var _t5;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              this.refundPreviewLoading = true;
              this.refundPreview = null;
              this.refundPreviewError = '';
              _context5.p = 1;
              _context5.n = 2;
              return (0, _rsManagement.getHotelRefundPreview)(this.refundOrderNo, 1);
            case 2:
              this.refundPreview = _context5.v;
              _context5.n = 4;
              break;
            case 3:
              _context5.p = 3;
              _t5 = _context5.v;
              this.refundPreviewError = _t5.message || '订单未配置退款规则';
            case 4:
              _context5.p = 4;
              this.refundPreviewLoading = false;
              return _context5.f(4);
            case 5:
              return _context5.a(2);
          }
        }, _callee5, this, [[1, 3, 4, 5]]);
      }));
      function loadHotelRefundPreview() {
        return _loadHotelRefundPreview.apply(this, arguments);
      }
      return loadHotelRefundPreview;
    }(),
    submitHotelRefund: function () {
      var _submitHotelRefund = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(refundMode) {
        var _t6;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              this.refundSubmitting = true;
              _context6.p = 1;
              _context6.n = 2;
              return (0, _rsManagement.refund)(this.refundOrderNo, refundMode);
            case 2:
              this.$message.success("\u8BA2\u5355 ".concat(this.refundOrderNo, " \u5DF2\u53D1\u8D77\u9000\u6B3E"));
              this.refundDialogVisible = false;
              this.getList();
              _context6.n = 4;
              break;
            case 3:
              _context6.p = 3;
              _t6 = _context6.v;
              this.$message.error('退款失败：' + (_t6.message || '未知错误'));
            case 4:
              _context6.p = 4;
              this.refundSubmitting = false;
              return _context6.f(4);
            case 5:
              return _context6.a(2);
          }
        }, _callee6, this, [[1, 3, 4, 5]]);
      }));
      function submitHotelRefund(_x) {
        return _submitHotelRefund.apply(this, arguments);
      }
      return submitHotelRefund;
    }(),
    changeToUsed: function changeToUsed(row) {
      var _this2 = this;
      var hotelName = row.productName ? row.productName : '---';
      this.$confirm('商品名称：' + hotelName + '<br/>订单状态变更为：已使用', '状态变更', {
        confirmButtonText: '确认',
        cancelButtonText: '关闭',
        dangerouslyUseHTMLString: true
      }).then(function () {
        (0, _rsManagement.changToUse)(row.orderNo).then(function (res) {
          _this2.getList();
          _this2.$message({
            type: 'success',
            message: '变更成功!'
          });
        }).catch(function (error) {
          _this2.$message({
            type: 'error',
            message: error
          });
        });
      }).catch(function () {
        _this2.$message({
          type: 'info',
          message: '已取消变更'
        });
      });
    }
  }
};